<template>
  <v-container
    fluid
    tile
    class="pa-0"
    :style="'background-color: ' + this.webTheme.colors.content.hexa + ';'"
  >
    <v-row no-gutters justify="center">
      <v-col xs="12" :sm="component.settings.cols">
        <v-sheet tile :color="this.webTheme.colors.content.hexa" :style="block">
          <v-row no-gutters justify="center">
            <v-col>
              <view-text :settings="component.title"></view-text>
            </v-col>
          </v-row>

          <v-row v-for="(category, id) in categories" :key="id" no-gutters>
            <v-col>
              <v-row no-gutters>
                <view-text
                  :settings="component.category"
                  :value="category.title"
                ></view-text>
              </v-row>

              <v-row
                v-if="component.card.group.slider === 'slide'"
                :justify="component.card.group.justify"
                no-gutters
              >
                <v-col :lg="component.card.group.cols">
                  <v-card
                    tile
                    elevation="0"
                    :class="grid.inner"
                    background-color="transparent"
                  >
                    <v-slide-group
                      :dark="component.card.group.dark"
                      show-arrows="always"
                    >
                      <v-slide-item
                        v-for="(card, i) in category.articleList"
                        :key="i"
                      >
                        <v-card
                          :class="classes"
                          :style="styles + ';' + gradient"
                          :height="cardHeight"
                          :width="component.card.width"
                          :elevation="component.card.elevation"
                          @click="openArticlePopUp(card)"
                        >
                          <v-img
                            v-if="component.image.show === true"
                            :height="component.image.height + 'px'"
                            :lazy-src="card.image.mediumUrl"
                            :src="card.image.mediumUrl"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                            <v-row
                              v-if="card.videoUrl"
                              justify="center"
                              align="center"
                              class="fill-height"
                              no-gutters
                            >
                              <v-btn fab large dark color="#21212185"
                                ><v-icon
                                  :color="webTheme.colors.primary.hex"
                                  size="50"
                                  >play_arrow</v-icon
                                ></v-btn
                              >
                            </v-row>
                          </v-img>
                          <v-card-text :style="cardText">
                            <v-row no-gutters v-if="card.title">
                              <v-col>
                                <view-text
                                  :settings="component.heading"
                                  :value="card.title"
                                />
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <view-text
                                  :settings="component.date"
                                  :value="date(card.updated)"
                                />
                              </v-col>
                              <v-col>
                                <view-text
                                  :settings="component.author"
                                  :value="getAuthorName(card.updatedBy)"
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              no-gutters
                              v-if="
                                card.body && component.settings.previewRows > 0
                              "
                            >
                              <v-col>
                                <view-text
                                  :settings="component.body"
                                  :value="card.body"
                                  :lines="component.settings.previewRows"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else no-gutters :justify="component.card.group.justify">
                <v-col :lg="component.card.group.cols">
                  <v-card tile elevation="0" :class="grid.inner">
                    <v-row
                      class="mx-2 mx-lg-0"
                      :justify="component.card.group.justify"
                    >
                      <v-card
                        v-for="(card, i) in category.articleList"
                        :key="i"
                        :class="classes"
                        :height="component.card.height"
                        :width="component.card.width"
                        :style="styles + ';' + gradient"
                        :elevation="component.card.elevation"
                        @click="openArticlePopUp(card)"
                      >
                        <v-img
                          v-if="component.image.show === true"
                          :height="component.image.height + 'px'"
                          :lazy-src="card.image.mediumUrl"
                          :src="card.image.mediumUrl"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                          <v-row
                            v-if="card.videoUrl"
                            justify="center"
                            align="center"
                            class="fill-height"
                            no-gutters
                          >
                            <v-btn fab large dark color="#21212185"
                              ><v-icon
                                :color="webTheme.colors.primary.hex"
                                size="50"
                                >play_arrow</v-icon
                              ></v-btn
                            >
                          </v-row>
                        </v-img>
                        <div>
                          <v-row no-gutters v-if="card.title">
                            <v-col>
                              <view-text
                                :settings="component.heading"
                                :value="card.title"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col>
                              <view-text
                                :settings="component.date"
                                :value="date(card.updated)"
                              />
                            </v-col>
                            <v-col>
                              <view-text
                                :settings="component.author"
                                :value="getAuthorName(card.updatedBy)"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="card.body">
                            <v-col>
                              <view-text
                                :settings="component.body"
                                :value="card.body"
                                :lines="4"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <article-dialog
      v-if="showArticle"
      :is-visible="showArticle"
      :on-close="closeArticlePopUp"
      :article="activeArticle"
      :component="component"
    ></article-dialog>

    <article-dialog-video
      v-if="showArticleVideo"
      :is-visible="showArticleVideo"
      :on-close="closeArticleVideoPopUp"
      :article="activeArticle"
    ></article-dialog-video>
  </v-container>
</template>

<script>
import ViewText from "../Text.vue";
import ArticleDialog from "./ArticleDialog.vue";
import ArticleDialogVideo from "./ArticleDialogVideo.vue";

import moment from "moment";

export default {
  components: {
    ViewText,
    ArticleDialog,
    ArticleDialogVideo
  },
  props: ["component"],
  async created() {
    // Explicitly load admins data and make sure it's loaded
    if (this.$store.getters.admins.length === 0) {
      this.$store.dispatch("loadAdmins");
    }

    // Load blog data based on route parameter
    await this.loadBlogData();
  },
  data: function() {
    return {
      showArticle: false,
      showArticleVideo: false,
      activeArticle: {},
      categories: []
    };
  },
  computed: {
    cardHeight() {
      if (this.component.card.autoHeight === true) {
        return "auto";
      }
      return this.component.card.height;
    },
    primary() {
      return this.webTheme.colors.primary.hex;
    },
    classes() {
      var classes = this.component.card.rounded;
      return classes;
    },
    grid() {
      return this.$store.getters.grid;
    },
    admins() {
      return this.$store.getters.admins;
    },
    block() {
      var padding = this.component.block.padding;
      return (
        this.grid.block +
        "px ;" +
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    cardText() {
      var padding = this.component.card.textAreaPadding;
      return (
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    gradient() {
      if (this.component.card.color.type === "gradient") {
        var color = this.component.card.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return "background: " + this.component.card.color.solidColor.hexa + ";";
      }
    },
    styles() {
      var styles =
        "margin-bottom: " +
        this.component.card.margin.bottom +
        "px ;" +
        "margin-top: " +
        this.component.card.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.card.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.card.margin.right +
        "px ;" +
        "padding-bottom: " +
        this.component.card.padding.bottom +
        "px ;" +
        "padding-top: " +
        this.component.card.padding.top +
        "px ;" +
        "padding-left: " +
        this.component.card.padding.left +
        "px ;" +
        "padding-right: " +
        this.component.card.padding.right +
        "px ;" +
        "border: " +
        this.component.card.borderSize +
        "px solid " +
        this.component.card.borderColor.hexa +
        "; ";
      return styles;
    },
    webTheme() {
      return this.$store.getters.currentProgram.webTheme;
    },
    // Unique to member website
    primaryMenus() {
      return this.$store.getters.primaryMenus;
    },
    screenDetail() {
      return (
        this.primaryMenus.find(
          menuDetail => menuDetail.content === this.$route.params.id
        ) || {}
      );
    },
    blogAuthorMap() {
      const admins = this.$store.getters.admins || [];
      if (admins.length === 0) {
        return {};
      }
      return admins.reduce((result, item) => {
        return {
          ...result,
          [item.userId]: item.name
        };
      }, {});
    }
  },
  watch: {
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId !== oldId && this && this.loadBlogData) {
          this.loadBlogData();
        }
      },
      immediate: false
    }
  },
  mounted() {
    // Component is mounted, data loading is handled in created()
  },
  methods: {
    date(date) {
      return moment(date).format("ddd MMMM Do YYYY");
    },
    getAuthorName(adminId) {
      return this.blogAuthorMap[adminId] || this.$t("AUTHOR") || "Author";
    },
    openArticlePopUp(article) {
      console.log("openArticlePopUp", article);
      this.activeArticle = article;
      if (article.videoUrl && article.videoOnlyPost === true) {
        this.openArticleVideoPopUp();
      } else {
        this.showArticle = true;
      }
    },
    closeArticlePopUp() {
      this.showArticle = false;
      this.activeArticle = null;
    },
    openArticleVideoPopUp() {
      this.showArticleVideo = true;
    },
    closeArticleVideoPopUp() {
      this.showArticleVideo = false;
      this.activeArticle = null;
    },
    async loadBlogData() {
      try {
        // Safety check to ensure Vue instance is available
        if (!this || !this.$route || !this.$store) {
          console.warn(
            "Component context not available, skipping blog data load"
          );
          return;
        }

        const blogId = this.$route.params.id;
        if (!blogId) {
          console.warn("No blog ID found in route params");
          return;
        }

        // Store reference to Vue instance to prevent context loss
        const vm = this;

        // Import Firebase functions
        const { db } = await import("@/firebase");
        const { doc, getDoc, collection, query, where, orderBy } = await import(
          "firebase/firestore"
        );

        const programId = this.$store.getters.programId;
        if (!programId) {
          console.warn("No program ID available");
          return;
        }

        const programRef = doc(db(), "programs", programId);
        const blogsRef = collection(programRef, "blogs");
        const blogRef = doc(blogsRef, blogId);

        // Get the specific blog document
        const blogDoc = await getDoc(blogRef);

        if (!blogDoc.exists()) {
          console.warn("Blog document not found:", blogId);
          if (vm && vm.categories !== undefined) {
            vm.categories = [];
          }
          return;
        }

        const blogData = blogDoc.data();

        try {
          // Get articles from the program level collection, filtered by blog ID
          const articlesRef = collection(programRef, "articles");

          // Use onSnapshot like in progress.js instead of getDocs
          const { onSnapshot } = await import("firebase/firestore");

          const unsubscribe = onSnapshot(
            query(
              articlesRef,
              where("status", "==", "Active"),
              where("blog", "==", blogId),
              orderBy("updated", "desc")
            ),
            articlesSnapshot => {
              // Check if component is still mounted
              if (!vm || vm.categories === undefined) {
                if (unsubscribe) {
                  unsubscribe();
                }
                return;
              }

              const articleList = [];

              articlesSnapshot.forEach(articleDoc => {
                const articleData = articleDoc.data();
                articleList.push({
                  id: articleDoc.id,
                  ...articleData,
                  updated: articleData.updated?.toDate() || new Date(),
                  created: articleData.created?.toDate() || new Date()
                });
              });

              // Structure the data as expected by the template
              vm.categories = [
                {
                  title: blogData.title || "Articles",
                  articleList: articleList
                }
              ];

              // Clean up the listener
              if (unsubscribe) {
                unsubscribe();
              }
            },
            error => {
              console.warn(
                "Articles: Cannot load articles, showing placeholder:",
                error.message
              );

              // Check if component is still mounted before updating
              if (!vm || vm.categories === undefined) {
                return;
              }

              // Show placeholder when articles can't be loaded
              vm.categories = [
                {
                  title: blogData.title || "Articles",
                  articleList: [
                    {
                      id: "placeholder",
                      title: "Articles Coming Soon",
                      body:
                        "Articles will be available here soon. Please check back later.",
                      updated: new Date(),
                      image: { mediumUrl: "" },
                      updatedBy: "system"
                    }
                  ]
                }
              ];
            }
          );
        } catch (articlesError) {
          console.warn(
            "Articles: Cannot load articles due to permissions, showing placeholder:",
            articlesError.message
          );

          // Check if component is still mounted before updating
          if (!vm || vm.categories === undefined) {
            return;
          }

          // Show placeholder when articles can't be loaded
          vm.categories = [
            {
              title: blogData.title || "Articles",
              articleList: [
                {
                  id: "placeholder",
                  title: "Articles Coming Soon",
                  body:
                    "Articles will be available here soon. Please check back later.",
                  updated: new Date(),
                  image: { mediumUrl: "" },
                  updatedBy: "system"
                }
              ]
            }
          ];
        }
      } catch (error) {
        console.error("Error loading blog data:", error);

        // Check if component is still mounted before updating
        if (!this || this.categories === undefined) {
          return;
        }

        // Show error placeholder
        this.categories = [
          {
            title: "Articles",
            articleList: [
              {
                id: "error",
                title: "Unable to Load Articles",
                body:
                  "There was an error loading articles. Please try again later.",
                updated: new Date(),
                image: { mediumUrl: "" },
                updatedBy: "system"
              }
            ]
          }
        ];
      }
    }
  }
};
</script>

<style scoped></style>
